import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'
import Carousel from '@/atoms/Carousel/Carousel'

interface Props {
  title: string
  description: string
  heroCta: StrapiLinkSharedComponent
  heroMediaCarousel: {
    id: string
    media: {
      data: {
        id: string
        attributes: StrapiImageFile
      }
    }
  }[]
}

function EventsPageHero({
  title,
  description,
  heroCta,
  heroMediaCarousel
}: Props) {
  return (
    <section className="font-heading">
      <div className="container | grid grid-cols-1 lg:grid-cols-12 gap-6 | py-14 md:py-24">
        <div className="lg:col-span-6 text-center md:text-left | mb-10 md:mb-0">
          <h1 className="text-4xl md:text-5xl font-semibold | mb-2 md:mb-5">
            {title}
          </h1>
          <p className="text-sm md:text-xl | mb-5 md:mb-14">{description}</p>
          <Link
            href={heroCta.href}
            target={heroCta.target}
            className="font-body | text-lg font-medium | new-btn-primary"
          >
            {heroCta.title}
          </Link>
        </div>
        <div className="lg:col-span-6 | rounded-3xl">
          <Carousel
            className="mx-auto | overflow-hidden"
            autoScroll={true}
            indicatorSize="sm"
            slides={heroMediaCarousel.map(media => {
              return (
                <Image
                  key={media.id}
                  src={media.media.data.attributes.url}
                  alt={media.media.data.attributes.alternativeText ?? ''}
                  width={media.media.data.attributes.width}
                  height={media.media.data.attributes.height}
                  priority={true}
                  className="border border-gray-50 rounded-3xl"
                />
              )
            })}
          />
        </div>
      </div>
    </section>
  )
}

export default EventsPageHero
